import React from "react";
import "./help.css";
import { Link } from "react-router";
const HelpScreen = () => {
  const styles = {
    container: {
      padding: "20px",
      backgroundColor: "#FFD400",
      fontFamily: "sans-serif",
      color: "#111",
    },
    title: {
      fontSize: "24px",
      marginTop: "20px",
      fontWeight: "bold",
      marginBottom: "10px",
      textAlign: "center",
    },
    section: {
      backgroundColor: "#fff",
      borderRadius: "10px",
      padding: "15px",
      marginBottom: "20px",
      marginLeft: "20px",
      marginRight: "20px",
    },
    sectionTitle: {
      fontSize: "18px",
      fontWeight: "bold",
      marginBottom: "10px",
    },
    list: {
      paddingLeft: "20px",
    },
    link: {
      color: "#007BFF",
      textDecoration: "none",
    },
  };

  return (
    <div className="help-screen-wrapper">
      <p className="home-logo-container">
        <img src={require("../../assets/images/logo.png")} alt="logo" />
      </p>
      <div style={styles.title}>IOU Hub Help</div>

      <div style={styles.section}>
        <div style={styles.sectionTitle}>
          Welcome! Need a quick guide before signing in?
        </div>
        <p>Here’s what you need to know:</p>
      </div>

      <div style={styles.section}>
        <div style={styles.sectionTitle}>Account Options</div>
        <p>
          <strong>Personal Account – For everyday users</strong>
        </p>
        <ul style={styles.list}>
          <li>Create and manage IOUs</li>
          <li>Add money, items, or services as tracked items</li>
          <li>Upload images for proof (receipts, payments, etc.)</li>
          <li>Set due dates, get reminders (Pro only)</li>
          <li>Use the built-in chat to communicate</li>
          <li>Scan QR codes to connect and share IOUs</li>
          <li>Export data and set recurring IOUs (Pro only)</li>
          <li>Free and Pro plans available</li>
        </ul>

        <p>
          <strong>
            Business Account – For vendors, service providers, or merchants
          </strong>
        </p>
        <p>Includes all Personal features, plus:</p>
        <p>
          <strong>Check-In Feature</strong>
        </p>
        <ul style={styles.list}>
          <li>Users scan your QR code to check in</li>
          <li>Track IOUs tied to the visit (both business and user)</li>
          <li>Makes IOU management faster and easier</li>
        </ul>
        <p>
          <strong>Rewards System</strong>
        </p>
        <ul style={styles.list}>
          <li>Create promotions or giveaways</li>
          <li>Users earn points when settling IOUs within a deadline</li>
          <li>Redeem points for discounts, freebies, or custom rewards</li>
          <li>Great for coffee shops, local vendors, etc.</li>
        </ul>
      </div>

      <div style={styles.section}>
        <div style={styles.sectionTitle}>What is IOU Hub?</div>
        <p>
          IOU Hub helps you track personal debts and IOUs — whether someone owes
          you, or you owe them.
        </p>
        <ul style={styles.list}>
          <li>Add detailed IOUs for money, goods, or services</li>
          <li>Attach images like receipts or payment proof</li>
          <li>Set due dates</li>
          <li>Keep a history of all transactions</li>
        </ul>
      </div>

      <div style={styles.section}>
        <div style={styles.sectionTitle}>How Do I Create an IOU?</div>
        <ul style={styles.list}>
          <li>Tap the Items tab to add what you're tracking</li>
          <li>Tap “+” to create a new IOU</li>
          <li>Enter or select a user</li>
          <li>Choose who owes whom</li>
          <li>Add one or more items</li>
          <li>Set a due date and submit</li>
        </ul>
      </div>

      <div style={styles.section}>
        <div style={styles.sectionTitle}>Can I Link an IOU to Someone?</div>
        <ul style={styles.list}>
          <li>Search their name while creating an IOU</li>
          <li>Add them as a friend via your profile</li>
          <li>Use the “Link User” button on existing IOUs</li>
        </ul>
      </div>

      <div style={styles.section}>
        <div style={styles.sectionTitle}>What Are "Items"?</div>
        <p>
          Items are what the IOU is about — like cash, goods, or services. Each
          IOU can contain one or more items.
        </p>
      </div>

      <div style={styles.section}>
        <div style={styles.sectionTitle}>Uploading Payment Proof</div>
        <ul style={styles.list}>
          <li>Open the relevant IOU</li>
          <li>Tap “Submit Payment”</li>
          <li>Upload your photo or screenshot</li>
          <li>The IOU owner will review and approve or reject it</li>
        </ul>
      </div>

      <div style={styles.section}>
        <div style={styles.sectionTitle}>Built-in Chat</div>
        <ul style={styles.list}>
          <li>Ask questions</li>
          <li>Discuss payments</li>
          <li>Share updates</li>
        </ul>
      </div>

      <div style={styles.section}>
        <div style={styles.sectionTitle}>Scan Feature</div>
        <ul style={styles.list}>
          <li>Add friends</li>
          <li>Share or accept items</li>
          <li>
            Check in at a Business account to automatically create an IOU.
          </li>
        </ul>
      </div>

      <div style={styles.section}>
        <div style={styles.sectionTitle}>Deleting Your Account</div>
        <p>
          You can delete your account anytime in the app. Go to profile then
          FAQs and tap on the delete account button.
        </p>
      </div>

      <div style={styles.section}>
        <div style={styles.sectionTitle}>Need Help?</div>
        <p>
          Contact us at:{" "}
          <a style={styles.link} href="mailto:sunal.fontinelle@gmail.com">
            sunal.fontinelle@gmail.com
          </a>
        </p>
      </div>
      <Link className="error-404-link" to="/">
        Go home
      </Link>
    </div>
  );
};
export default HelpScreen;
